export default __webpack_public_path__ + "static/2s-d3bbd5272de0e0c4a7f6b3301bb3a157.jpg";